import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Team from '../components/sections/Team';
import Values from '../components/sections/Values';
import BlogPreview from '../components/sections/BlogPreview';
import Instagram from '../components/sections/Instagram';
import Contact from '../components/sections/Contact';
import ContactModal from '../components/ContactModal';

export default function Home() {
  const [showContactModal, setShowContactModal] = useState(false);

  const openContactModal = () => setShowContactModal(true);
  const closeContactModal = () => setShowContactModal(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Inerva Psicología | Clínica Online de Psicología</title>
        <meta
          name="description"
          content="Clínica online de psicología para personas adultas. Acompañamiento en ansiedad, crisis vitales, trauma, procesos de identidad y acompañamiento afirmativo LGTBIQA+. Sesiones online."
        />
        <meta
          name="keywords"
          content="psicología online, clínica psicología, terapia online, ansiedad, estrés, trauma, LGTBIQA+, terapia afirmativa, salud mental"
        />
        <link rel="canonical" href="https://www.inervapsicologia.es" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Inerva Psicología | Clínica Online de Psicología" />
        <meta
          property="og:description"
          content="Clínica online de psicología. Acompañamiento cercano, afirmativo y sin juicios."
        />
        <meta property="og:url" content="https://www.inervapsicologia.es" />
        <meta property="og:site_name" content="Inerva Psicología" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Inerva Psicología | Clínica Online de Psicología" />
        <meta
          name="twitter:description"
          content="Clínica online de psicología. Acompañamiento cercano, afirmativo y sin juicios."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'MedicalBusiness',
            name: 'Inerva Psicología',
            description: 'Clínica online de psicología para personas adultas. Acompañamiento en ansiedad, crisis vitales, trauma, procesos de identidad y acompañamiento afirmativo LGTBIQA+.',
            url: 'https://www.inervapsicologia.es',
            telephone: '+34626235122',
            email: 'inerva.psicologia@gmail.com',
            priceRange: '$$',
            areaServed: {
              '@type': 'Country',
              name: 'España',
            },
            serviceType: [
              'Ansiedad y crisis de angustia',
              'Estrés, rumiación y bloqueo emocional',
              'Crisis vitales',
              'Trauma y experiencias difíciles',
              'Autoestima, límites y relaciones',
              'Procesos de identidad',
              'Acompañamiento afirmativo LGTBIQA+',
            ],
            availableChannel: {
              '@type': 'ServiceChannel',
              serviceType: ['Online'],
            },
          })}
        </script>
      </Helmet>

      <Header />

      <main>
        <Hero onContactClick={openContactModal} />
        <div className="reveal"><About /></div>
        <div className="reveal"><Instagram /></div>
        <div className="reveal"><Team /></div>
        <div className="reveal"><Values /></div>
        <div className="reveal"><BlogPreview /></div>
        <Contact onContactClick={openContactModal} />
      </main>

      <Footer />

      <ContactModal show={showContactModal} handleClose={closeContactModal} />
    </>
  );
}
